import React from "react";
import { Navbar } from "reactstrap";
import classnames from "classnames";
import NavbarBookmarks from "./NavbarBookmarks";
import NavbarUser from "./NavbarUser";
import userImg from "../../../assets/img/portrait/small/avatar-s-11.jpg";
import SidebarRideFlexLogo from "../../../assets/img/logo/logo_rideflex_small.svg";
import logo_new from '../../../assets/img/logo/ic_ride_flex_logo_header.svg'
import Sidebar from "../menu/horizontal-menu/HorizontalMenu";

const ThemeNavbar = (props) => {
  const colorsArr = ["primary", "danger", "success", "info", "warning", "dark"];
  const navbarTypes = ["floating", "static", "sticky", "hidden"];
  return (
    <React.Fragment>
      <div className="content-overlay" />
      <div className="header-navbar-shadow" />
      <Navbar
        className={classnames(
          "header-navbar navbar-expand-lg navbar navbar-with-menu navbar-shadow bg-dark",
          {
            "navbar-light":
              props.navbarColor === "default" ||
              !colorsArr.includes(props.navbarColor),
            "navbar-dark": colorsArr.includes(props.navbarColor),
            "bg-primary":
              props.navbarColor === "primary" && props.navbarType !== "static",
            "bg-danger":
              props.navbarColor === "danger" && props.navbarType !== "static",
            "bg-success":
              props.navbarColor === "success" && props.navbarType !== "static",
            "bg-info":
              props.navbarColor === "info" && props.navbarType !== "static",
            "bg-warning":
              props.navbarColor === "warning" && props.navbarType !== "static",
            "bg-dark":
              props.navbarColor === "dark" && props.navbarType !== "static",
            "d-none": props.navbarType === "hidden" && !props.horizontal,
            "floating-nav":
              (props.navbarType === "floating" && !props.horizontal) ||
              (!navbarTypes.includes(props.navbarType) && !props.horizontal),
            "navbar-static-top":
              props.navbarType === "static" && !props.horizontal,
            "fixed-top": props.navbarType === "sticky" || props.horizontal,
            scrolling: props.horizontal && props.scrolling,
          }
        )}
      >
        <div className="navbar-wrapper">
          <div className="navbar-container content">
            <div
              className="navbar-collapse d-flex justify-content-between align-items-center mt-1"
              id="navbar-mobile"
            >
              {/* <div className="bookmark-wrapper">
                <NavbarBookmarks
                  sidebarVisibility={props.sidebarVisibility}
                  handleAppOverlay={props.handleAppOverlay}
                />
              </div> */}
              {props.horizontal ? (
                <div className="d-flex align-items-center" style={{paddingLeft:'24px'}}>
                  <img
                    style={{ width: "50x", maxHeight: "50px" }}
                    src={logo_new}
                    alt="sidebar RideFlex logo"
                  />
                  {/* <div className="ml-1" style={{color:'#FBBC04',fontSize:'28px'}} >
                    RIDEFLEX
                  </div> */}
                </div>
              ) : // <div className="logo d-flex align-items-center">
              //   <div className="brand-logo mr-50"></div>
              //   <h2 className="text-primary brand-text mb-0">RideFlex</h2>
              // </div>
              null}
              <NavbarUser
                handleAppOverlay={props.handleAppOverlay}
                changeCurrentLang={props.changeCurrentLang}
                userName="Demo test"
                userImg={userImg}
              />
            </div>
            <div>
              <Sidebar
                toggleSidebarMenu={props.toggleSidebarMenu}
                sidebarState={props.sidebarState}
                sidebarHover={props.sidebarHover}
                sidebarVisibility={props.sidebarVisibility}
                visibilityState={props.visibilityState}
                activePath={props.activePath}
                currentLang={props.currentLang}
                activeTheme={props.activeTheme}
                collapsed={props.collapsed}
                menuOpen={props.menuOpen}
                navbarType={props.navbarType}
              />
            </div>
          </div>
        </div>
      </Navbar>
    </React.Fragment>
  );
};

export default ThemeNavbar;
